import styled from 'styled-components';
import { Stack } from '@mantine/core';

export const FormStack = styled(Stack)`
	gap: 16px;
`;
